module.exports = "<div class=\"map-container\" id=\"mapcontainer{{widgetId}}\">\r\n  <div class=\"map-frame\">\r\n    <div class=\"geoMap\" id=\"geoMap{{widgetId}}\"></div>\r\n  </div>\r\n</div>\r\n<div class=\"geo_siteList\">\r\n  <ng-container *ngFor=\"let ct of latlngs\">\r\n    <a (click)=\"setSiteInToView(ct.view)\"><i class=\"fi flaticon-location-1\"></i> {{ct.name}}</a>\r\n  </ng-container>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// D:/Xpand-Dubai/xpand_retail_int/Customers/app/src/app/shared/components/graphs/geo-map/geo-map.component.html
// module id = ../../../../../src/app/shared/components/graphs/geo-map/geo-map.component.html
// module chunks = main